import { render, staticRenderFns } from "./JwJianzhuModal.vue?vue&type=template&id=0891c7f2&scoped=true"
import script from "./JwJianzhuModal.vue?vue&type=script&lang=js"
export * from "./JwJianzhuModal.vue?vue&type=script&lang=js"
import style0 from "./JwJianzhuModal.vue?vue&type=style&index=0&id=0891c7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891c7f2",
  null
  
)

export default component.exports